import { InfiniteSlider } from '@/js/infinite-slider';

export const CarInsuranceView = {
    init() {
        InfiniteSlider.init();
        this.initResetButton();
    },

    initResetButton() {
        const resetBtn = document.getElementById('reset-insurance-btn');
        const prefilledBox = document.querySelector('.prefilled-car-box');

        if (resetBtn) {
            resetBtn.addEventListener('click', () => {
                if (prefilledBox) {
                    prefilledBox.style.display = 'none';
                }

                const slugInputs = document.querySelectorAll('input[name$="[slug]"]');
                slugInputs.forEach(input => {
                    input.value = '';
                });

                const vinInput = document.getElementById('vin-input');
                if (vinInput) vinInput.value = '';

                const mileageInput = document.getElementById('mileage-input');
                if (mileageInput) mileageInput.value = '';

                const priceInput = document.getElementById('price-input');
                if (priceInput) priceInput.value = '';

                window.history.pushState({}, '', window.location.pathname);
            });
        }
    }
};
